export default Object.freeze({
  settings: {},
  recipients: [],
});
